import { render, staticRenderFns } from "./AddParameterInsightsWidget.vue?vue&type=template&id=7201637a"
import script from "./AddParameterInsightsWidget.vue?vue&type=script&lang=js"
export * from "./AddParameterInsightsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports